export default "__VITE_ASSET__c9917932__"